import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import AutoSizer from "react-virtualized-auto-sizer";

import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import AppPageTableHeader from "components/AppPageTableHeader";
import AppPageTableContent from "components/AppPageTableContent";
import AppPageTable from "components/AppPageTable";
import AppPageTableRowContent from "components/AppPageTableRowContent";
import Loader from "components/Loader";
import ScrollSync from "components/ScrollSync";
import VirtualList from "components/VirtualList";

import routes from "common/routes";
import { useInfiniteScroll } from "hooks/useInfiniteScroll";
import { usePageState } from "./usePageState";
import useStyles from "./styles";

interface IProps {
  query?: string;
}

const Users = (props: IProps) => {
  const { query } = props;
  const classes = useStyles();
  const history = useHistory();
  const tableBodyRef = useRef<HTMLDivElement>(null);
  const { isLoading, users, fetchNextPage, isFetchingNextPage, hasNextPage } =
    usePageState(query);

  useInfiniteScroll(
    tableBodyRef,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    true,
    true
  );

  const renderTableHead = () => {
    return (
      <AppPageTableHeader className={classes.appPageTableHeader}>
        <AppPageTableRowContent
          className={clsx(
            classes.tableHeaderContainer,
            classes.appPageTableRowContent
          )}
        >
          <Box className={classes.rowContent} role="row">
            <Box className={classes.rowCell} role="cell">
              Name
            </Box>
            <Box className={classes.rowCell} role="cell">
              Email
            </Box>
            <Box className={classes.rowCell} role="cell">
              Phone
            </Box>
            <Box className={classes.rowCell} role="cell">
              License
            </Box>
            <Box
              className={clsx(classes.rowCell, classes.rowCellCenter)}
              role="cell"
            >
              Actions
            </Box>
          </Box>
        </AppPageTableRowContent>
      </AppPageTableHeader>
    );
  };

  const renderRows = () => {
    return users.map(item => (
      <div key={item.id} className={classes.appPageTableRow}>
        <AppPageTableRowContent className={classes.appPageTableRowContent}>
          <Box className={classes.rowContent}>
            <Box className={classes.rowCell} role="cell">
              {item.firstName} {item.lastName}
            </Box>
            <Box className={classes.rowCell} role="cell">
              {item.email}
            </Box>
            <Box className={classes.rowCell} role="cell">
              {item.phoneNumber}
            </Box>
            <Box className={classes.rowCell} role="cell">
              {item.licenseNumber}
            </Box>
            <Box
              className={clsx(classes.rowCell, classes.rowCellCenter)}
              role="cell"
            >
              <Button
                size={"small"}
                onClick={() =>
                  history.push(
                    routes.adminEditUser.path.replace(":userId", item.id)
                  )
                }
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
            </Box>
          </Box>
        </AppPageTableRowContent>
      </div>
    ));
  };

  const renderTable = () => {
    return (
      <AppPageTable rootRef={tableBodyRef}>
        <ScrollSync enabled={true}>
          {renderTableHead()}
          <AppPageTableContent>
            <AutoSizer>
              {({ height, width }) => (
                <VirtualList
                  className={classes.virtualList}
                  itemClassName={classes.virtualListItem}
                  count={users.length}
                  itemHeight={46}
                  height={height}
                  width={width}
                  scrollContainerRef={tableBodyRef}
                  itemsBeyond={4}
                >
                  {renderRows()}
                </VirtualList>
              )}
            </AutoSizer>
          </AppPageTableContent>
        </ScrollSync>
      </AppPageTable>
    );
  };

  return (
    <>
      {!isLoading && renderTable()}
      {isLoading && <Loader overlay className={classes.overlayLoader} />}
      {isFetchingNextPage && <Loader infinite />}
    </>
  );
};

export default Users;
